import {
  GenerationStatus,
  type ScreenerBuilderResponse,
  ScreenerBuilderStep,
} from "@/types/screener-builder";
import type { Nullable } from "@/types/utils";
import { EMPTY_BUILDER_CONTEXT } from "@/utils/screener-builder";
import { capitalizeFirstLetter } from "@/utils/ui";

export const generateAlternativeBuilderInfo = (
  screenerId: string,
  name: string,
  displayName: Nullable<string> = null,
): ScreenerBuilderResponse => ({
  data: {
    context: EMPTY_BUILDER_CONTEXT,
    position: {
      internalName: displayName,
      isHighTurnoverRole: null,
      jobDescription: "",
      jobTitle: name,
      seniorityLevel: null,
    },
  },
  generationStatus: GenerationStatus.Complete,
  isLegacyScreener: true,
  published: true,
  screenerId: screenerId,
  step: ScreenerBuilderStep.Review,
});

export const parseCompetencyDefinition = (text: string) => {
  if (!text) {
    return { high: "", medium: "", low: "" };
  }

  const normalizedText = text.replace(/\n/g, " ");

  const highMatch = normalizedText.match(
    /High\s+[Ff]it\s*:?(.*?)(?=Medium\s+[Ff]it|$)/i,
  );
  const mediumMatch = normalizedText.match(
    /Medium\s+[Ff]it\s*:?(.*?)(?=Low\s+[Ff]it|$)/i,
  );
  const lowMatch = normalizedText.match(/Low\s+[Ff]it\s*:?(.*?)$/i);

  const high = highMatch?.[1]?.trim() || "";
  const medium = mediumMatch?.[1]?.trim() || "";
  const low = lowMatch?.[1]?.trim() || "";

  const toSentenceCase = (str: string) => {
    if (!str) return "";
    return capitalizeFirstLetter(str);
  };

  return {
    high: toSentenceCase(high),
    medium: toSentenceCase(medium),
    low: toSentenceCase(low),
  };
};
